import React, { useState, useEffect } from "react";
import { BsChevronDown } from "react-icons/bs";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import PowerBi from "@pages/PowerBi";

const PbiDashboard = ({ showDropdown, showDealer = false }) => {
  const [selectedValue, setSelectedValue] = useState("Team");
  const [id, setId] = useState(0);
  const [pageName, setPageName] = useState();
  const data = [
    {
      dropdownItems: "Team",
      id: 0,
    },
    {
      dropdownItems: "WSS",
      id: 1,
    },
    {
      dropdownItems: "Dealer",
      id: 2,
    },
    // {
    //   dropdownItems: "Exception Deal",
    //   id: 1,
    // },
    // {
    //   dropdownItems: "User",
    //   id: 2,
    // },

    // {
    //   dropdownItems: "Diary",
    //   id: 4,
    // },
    // {
    //   dropdownItems: "Product",
    //   id: 5,
    // },

    // {
    //   dropdownItems: "Tour Report",
    //   id: 7,
    // },
  ];

  // eslint-disable-next-line no-unused-vars
  const onChangeHandler = (e) => {
    setSelectedValue(e.target.value);
  };

  //to set pageNumber value
  useEffect(() => {
    switch (selectedValue) {
      case "Team":
        setPageName("ReportSection5503edccfcd9c5405c5c");
        break;
      case "Exception Deal":
        setPageName("0120l000001GzOEAA0");
        break;
      case "WSS":
        setPageName("ReportSectionaff09e82ef2ddea135bb");
        break;
      case "User":
        setPageName("0120l000001GzO4AAK");
        break;
      case "Diary":
        setPageName("0120l000001GzO4AAK");
        break;
      case "Product":
        setPageName("0120l000001GzOEAA0");
        break;
      case "Dealer":
        setPageName("ReportSection");
        break;
      default:
        break;
      case "Tour Report":
        setPageName("0120l000001GzOEAA0");
        break;
    }
  }, [selectedValue]);

  return (
    <div className="px-4 py-2.5">
      {/* Header row */}
      <div className="flex justify-between items-center">
        <div className="text-primary font-semibold text-base leading-5">PBI Dashboard</div>

        {showDropdown && (
          <Dropdown>
            <Dropdown.Toggle
              id="dropdown-basic"
              className="!bg-transparent !text-blue-600 !text-[10px] !font-semibold !border-0 !shadow-none after:!hidden flex items-center gap-1.5"
            >
              <span className="text-xs">{selectedValue}</span>
              <BsChevronDown />
            </Dropdown.Toggle>

            <Dropdown.Menu
              className="!border-0 shadow-[0.9px_0.9px_3.86px_rgba(20,20,20,0.07)] min-w-[5rem] !translate-x-[-15px] !translate-y-[32px]"
            >
              <div className="px-2.5">
                {data.map((item, index) => {
                  return (
                    <div key={index}>
                      <Dropdown.Item
                        href="#/action-1"
                        className="!flex items-center !text-[10.5px] !py-0.5 !px-1.5 hover:!bg-white focus:!bg-white w-[130%]"
                      >
                        <Form.Check
                          type="radio"
                          name="group"
                          aria-label="radio 1"
                          className="[&_input]:!w-[15px] [&_input]:!h-[15px] md:[&_input]:!w-5 md:[&_input]:!h-5 [&_input:checked]:!bg-success [&_input:checked]:!border-success"
                          checked={selectedValue && index === id ? true : false}
                          value={item?.dropdownItems}
                          id={index + 1}
                          onChange={(e) => {
                            setSelectedValue(e.target.value);
                            setId(item?.id);
                          }}
                        />
                        <label
                          htmlFor={index + 1}
                          className="ml-1.5 self-center py-1 font-roboto font-medium text-[11.83px] leading-[10px] cursor-pointer md:text-[14.83px] md:leading-5"
                        >
                          {item?.dropdownItems}
                        </label>
                      </Dropdown.Item>
                    </div>
                  );
                })}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>

      {/* Report embed */}
      <div className="w-full h-full mb-2">
        {showDealer ? (
          <PowerBi
            id="d4345e64-7c35-46f7-b844-8f2f5443dd2d"
            pageName={{
              id: "ReportSection",
              name: "ReportSection",
            }}
          />
        ) : (
          <PowerBi
            id="d4345e64-7c35-46f7-b844-8f2f5443dd2d"
            pageName={{
              id: pageName,
              name: pageName,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PbiDashboard;
